import {
  SHOW_ADAPTIVE_PAGES,
  SHOW_PILLAR_PAGES,
  SHOW_COLLABORATION,
  SHOW_SITEMAP,
  ALL_ADAPTIVE_PAGES,
  ALL_PILLAR_PAGES,
  SELECTED_SECTION,
  SHOW_GLOBAL_SECTIONS,
  SHOW_ALL_COMMENTS,
  SELECTED_TAB,
  SAVE_SITEMAP,
  SAVE_BUSINESS,
} from '../constants/generativeStudioConstants'

interface State {
  selectedTab: any
  showCollaboration: any
  showAdaptivePages: any
  showPillarPages: any
  showSiteMap: any
  showGlobalNodes: any
  showAllComments: any
  allAdaptivePagesR: any
  allPillarPagesR: any
  selectedSectionR: any
  saveSitemap: any
  business: any
}

const initialState: State = {
  selectedTab: 'Wireframe',
  showCollaboration: false,
  showAdaptivePages: false,
  showPillarPages: false,
  showSiteMap: false,
  showGlobalNodes: false,
  showAllComments: false,
  allAdaptivePagesR: null,
  allPillarPagesR: null,
  selectedSectionR: {
    name: 'main',
    id: 'main',
  },
  saveSitemap: false,
  business: null,
}

export const generativeStudioReducer = (state: State = {...initialState}, action: any): State => {
  switch (action?.type) {
    case SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      }
    case SHOW_COLLABORATION:
      return {
        ...state,
        showCollaboration: action.payload,
      }

    case SHOW_ADAPTIVE_PAGES:
      return {
        ...state,
        showAdaptivePages: action.payload,
      }

    case SHOW_PILLAR_PAGES:
      return {
        ...state,
        showPillarPages: action.payload,
      }

    case SHOW_SITEMAP:
      return {
        ...state,
        showSiteMap: action.payload,
      }

    case SHOW_GLOBAL_SECTIONS:
      return {
        ...state,
        showGlobalNodes: action.payload,
      }

    case SHOW_ALL_COMMENTS:
      return {
        ...state,
        showAllComments: action.payload,
      }

    case ALL_ADAPTIVE_PAGES:
      return {
        ...state,
        allAdaptivePagesR: action.payload,
      }

    case ALL_PILLAR_PAGES:
      return {
        ...state,
        allPillarPagesR: action.payload,
      }

    case SELECTED_SECTION:
      return {
        ...state,
        selectedSectionR: action.payload,
      }

    case SAVE_SITEMAP:
      return {
        ...state,
        saveSitemap: action.payload,
      }

    case SAVE_BUSINESS:
      return {
        ...state,
        business: action.payload,
      }

    default:
      return state
  }
}
